import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Link, Grid } from "@material-ui/core";
import { useMenu } from "./MenuContext";
import { colors } from "../../theme";
import clsx from "clsx";
import ArrowRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme) => ({
  menu: {
    fontSize: "20px",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.05px",
    color: colors.MENU_ITEM,
  },
  active: {
    fontWeight: "bold",
    color: colors.MENU_ITEM_ACTIVE,
  },
  icon: {
    fontSize: "32px",
  },
}));

export default function MenuItem({
  to,
  children,
}: {
  to: string;
  children: string;
}) {
  const classes = useStyles();
  const { closeMenu } = useMenu();
  const { pathname: url } = useLocation();

  const active =
    (url === "/" && to === "/") || (to !== "/" && url.startsWith(to));

  return (
    <Grid container item style={{ margin: "10px" }}>
      <Link
        component={RouterLink}
        to={to}
        onClick={closeMenu}
        className={clsx(classes.menu, active && classes.active)}
      >
        <Grid container item direction="row" justify="center">
          <Grid item>
            <ArrowRightIcon
              className={classes.icon}
              style={{ visibility: active ? "visible" : "hidden" }}
            />
          </Grid>
          <Grid item style={active ? { paddingTop: "3px" } : undefined}>
            {children}
          </Grid>
        </Grid>
      </Link>
    </Grid>
  );
}
